/**
 * @generated SignedSource<<ccf087f4126298fb0de84e0ba06dd1bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserBalanceRefetchQuery$variables = {
  id: string;
};
export type UserBalanceRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"UserBalance_balance">;
  } | null;
};
export type UserBalanceRefetchQuery = {
  response: UserBalanceRefetchQuery$data;
  variables: UserBalanceRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBalanceRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBalance_balance"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserBalanceRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyAmount",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formatted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subUnitAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "WalletBalance",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "db0ec22f3e4302f8187ccfc127266200",
    "id": null,
    "metadata": {},
    "name": "UserBalanceRefetchQuery",
    "operationKind": "query",
    "text": "query UserBalanceRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UserBalance_balance\n    id\n  }\n}\n\nfragment UserBalance_balance on WalletBalance {\n  amount {\n    currency\n    formatted\n    subUnitAmount\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "3424bd3ea88adcb2a83bae5cf8c50218";

export default node;
